var _path, _circle, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNfMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.800003V33.2H26.15V9.02462L25.7653 8.65077L18.0703 1.17385L17.6855 0.800003H0.5ZM3.065 3.29231H15.89V10.7692H23.585V30.7077H3.065V3.29231ZM18.455 5.03693L21.7895 8.27693H18.455V5.03693ZM5.63 13.2615V15.7539H21.02V13.2615H5.63ZM5.63 19.4923V21.9846H14.6075V19.4923H5.63ZM17.1725 19.4923V21.9846H21.02V19.4923H17.1725ZM5.63 24.4769V26.9692H14.6075V24.4769H5.63ZM17.1725 24.4769V26.9692H21.02V24.4769H17.1725Z",
    fill: "#0C7488"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 27,
    r: 9,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8674 23.6866V28.3389L14.7949 23.6866H13.438V30.4615H14.7949V25.8189L17.8674 30.4615H19.2243V23.6866H17.8674Z",
    fill: "#0C7488"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5652 30.4615H21.9222V27.6023H24.0835V26.5265H21.9222V24.7915H24.7426V23.6963H20.5652V30.4615Z",
    fill: "#0C7488"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfMenuIcon);
export default __webpack_public_path__ + "static/media/nf-menu-icon.6be063e35f9af5e7c6a0d1719be5cef4.svg";
export { ForwardRef as ReactComponent };